import React from 'react';
import PrivateRoute from 'PrivateRoutes';
import { SmsProvider } from './components';

const routes = () => (
  <PrivateRoute
    exact
    path="/settings/SMS-Provider"
    component={SmsProvider}
  />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/settings/SmsProvider/routes.js